// src/App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import PrivateRoute from './components/PrivateRoute';
import LoginPage from './pages/LoginPage';
import ContentResourceManagement from './pages/ContentResourceManagement';
import UsersAndSales from './pages/UsersAndSales';
import UserActivity from './pages/UserActivity';
import MutualTransfer from './pages/MutualTransfer';
import UserFeedback from './pages/UserFeedback';
import Experts from './pages/Experts';
import TransactionRecords from './pages/TransactionRecords';
import Scheduler from './pages/Scheduler';
import AvailableSchedules from './components/AvailableSchedules';
import EditShedular from './pages/EditShedular';
import Hiring from './pages/Hiring';
import Contactus from './pages/contactus';
import AdminStatistics from './pages/AdminStatistics';
import PromoCodesPage from './pages/PromoCodesPage';

// ✅ Helper can be outside App – good practice
const isTokenValid = () => {
  const stored = localStorage.getItem('Atoken');
  if (!stored) return false;

  try {
    const parsed = JSON.parse(stored);
    const { token, expiry } = parsed;

    if (!token || !expiry) {
      localStorage.removeItem('Atoken');
      return false;
    }

    // If current time > expiry → token expired
    if (Date.now() > expiry) {
      localStorage.removeItem('Atoken');
      return false;
    }
    return true;
  } catch (err) {
    console.error('Failed to parse Atoken', err);
    localStorage.removeItem('Atoken');
    return false;
  }
};

const App = () => {
  // ✅ uses function initializer, runs isTokenValid only once
  const [isAuthenticated, setIsAuthenticated] = useState(isTokenValid);

  const handleLogout = () => {
    localStorage.removeItem('Atoken');
    setIsAuthenticated(false);
    // PrivateRoute should already redirect, but you can force:
    window.location.href = '/login';
  };

  // ✅ One-time cleanup: remove old tokens that have no expiry
  useEffect(() => {
    const stored = localStorage.getItem('Atoken');

    if (stored) {
      try {
        const parsed = JSON.parse(stored);

        if (!parsed.expiry) {
          localStorage.removeItem('Atoken');
          setIsAuthenticated(false);
          window.location.href = '/login';
        }
      } catch {
        localStorage.removeItem('Atoken');
        setIsAuthenticated(false);
        window.location.href = '/login';
      }
    }
  }, []);

  // ✅ Auto-logout exactly when expiry is reached
  useEffect(() => {
    if (!isAuthenticated) return;

    const stored = localStorage.getItem('Atoken');
    if (!stored) return;

    try {
      const { expiry } = JSON.parse(stored);
      const remaining = expiry - Date.now();

      if (remaining <= 0) {
        handleLogout();
        return;
      }

      const timerId = setTimeout(() => {
        handleLogout();
      }, remaining);

      return () => clearTimeout(timerId);
    } catch {
      handleLogout();
    }
  }, [isAuthenticated]);

  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={<LoginPage setIsAuthenticated={setIsAuthenticated} />}
        />
        <Route
          path="/*"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated}>
              <div className="d-flex">
                <Sidebar setIsAuthenticated={setIsAuthenticated} />
                <div className="content p-4">
                  <Routes>
                    <Route
                      path="/content-resource-management"
                      element={<ContentResourceManagement />}
                    />
                    <Route path="/users-sales" element={<UsersAndSales />} />
                    <Route path="/user-activity" element={<UserActivity />} />
                    <Route path="/mutual-transfer" element={<MutualTransfer />} />
                    <Route path="/user-feedback" element={<UserFeedback />} />
                    <Route path="/experts" element={<Experts />} />
                    <Route
                      path="/transaction-records"
                      element={<TransactionRecords />}
                    />
                    <Route path="/scheduler" element={<Scheduler />} />
                    <Route
                      path="/available-schedules"
                      element={<AvailableSchedules />}
                    />
                    <Route path="/Edit-schedules" element={<EditShedular />} />
                    <Route path="/Hiring-records" element={<Hiring />} />
                    <Route path="/Contactus" element={<Contactus />} />
                    <Route
                      path="/AdminStatistics"
                      element={<AdminStatistics />}
                    />
                    <Route path="/Promocodes" element={<PromoCodesPage />} />
                  </Routes>
                </div>
              </div>
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
